function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "var(--color-monochrome-dark)",
  d: "M19.474 8.298h-2.07l.723-3.028a1.033 1.033 0 00-.745-1.23c-.586-.162-1.193.185-1.33.761l-.836 3.497h-4.792l.724-3.028a1.033 1.033 0 00-.746-1.23c-.586-.162-1.193.185-1.33.761l-.835 3.497H5.845c-.567 0-1.026.446-1.026.996 0 .551.46.997 1.026.997H7.76l-.816 3.418H4.526c-.567 0-1.026.446-1.026.997 0 .55.46.996 1.026.996h1.941l-.723 3.028c-.128.538.2 1.078.745 1.23.586.162 1.193-.185 1.331-.762l.835-3.496h4.792l-.723 3.028c-.129.538.199 1.078.745 1.23.586.162 1.193-.185 1.33-.762l.836-3.496h2.374c.566 0 1.025-.446 1.025-.996 0-.551-.459-.997-1.025-.997H16.11l.817-3.418h2.546c.567 0 1.026-.446 1.026-.997 0-.55-.46-.996-1.026-.996zm-5.55 5.41H9.13l.817-3.417h4.792l-.817 3.418z"
});

function SvgHashtag(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default ForwardRef;